module.exports = "https://redage.akamaized.net/src/views/donate/main/elements/shop/img/p_2.svg";